import React, {
  useEffect,
  useMemo,
  useCallback,
  useRef,
  useState,
} from "react";
import { useAdvSearch } from "../providers/advSearchCtx";
import { useInfiniteQuery } from "@tanstack/react-query";
import SingleListing from "../components/ListingsList/SingleListing";
import ListingLoader from "../components/UI/ListingLoader";
import { getListings } from "../lib/utils";
import debounce from "lodash/debounce";

export default function ListingsList() {
  const { centerCoords, params } = useAdvSearch();
  const sentineRef = useRef(null);

  // const debouncedSearchParams = useMemo(
  //   debounce(() => ({
  //     bounds: centerCoords.bounds,
  //     ...params,
  //     page: 1,
  //     per_page: 10,
  //   })),
  //   [centerCoords, params],
  // );

  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    status,
    isLoading,
  } = useInfiniteQuery({
    queryKey: ["listings", centerCoords, params],
    queryFn: ({ pageParam = 1 }) => {
      return getListings({
        bounds: centerCoords.bounds,
        ...params,
        page: 1,
        per_page: 10,
      });
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, pages) => {
      const nextPage = pages.length + 1;
      return nextPage <= lastPage.data.max_pages ? nextPage : undefined;
    },
  });

  const listings = useMemo(
    () => data?.pages?.flatMap((page) => page.data?.listings || []) ?? [],
    [data],
  );

  const handleScroll = useCallback(() => {
    if (scrollPosition >= bottom && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

  const showSentinel = useMemo(
    () => hasNextPage && !isFetchingNextPage,
    [hasNextPage, isFetchingNextPage],
  );
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && hasNextPage && !isFetchingNextPage) {
        fetchNextPage();
      }
    });
    if (sentineRef.current) {
      observer.observe(sentineRef.current);
    }

    return () => {
      if (sentineRef.current) {
        observer.unobserve(sentineRef.current);
      }
    };
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);
  // const Observer = new IntersectionObserver((entries) => {
  //   if (entries[0].isIntersecting && hasNextPage && !isFetchingNextPage) {
  //     fetchNextPage();
  //   }
  // });
  // Observer.observe(sentineRef.current);

  return (
    <div>
      {!isLoading && (
        <div className="listing-results-bar uk-padding-xsmall">
          <div className="uk-animation-slide-top uk-h4 uk-flex uk-flex-between">
            <div className="uk-text-small">
              <strong>
                Risultati: {data?.pages[0]?.data?.found_posts || 0}
              </strong>
            </div>
          </div>
        </div>
      )}
      {listings.length === 0 && !isLoading && (
        <div className="uk-animation-slide-top">
          <h4 className="uk-text-center">Nessun annuncio trovato</h4>
        </div>
      )}
      <div className="listing-react-wrapper uk-position-relative">
        <div
          className="listings-list uk-child-width-1-2@s uk-grid-collapse uk-padding-small uk-padding-remove-top"
          uk-grid="masonry: true"
        >
          {listings.map((listing) => (
            <SingleListing listing={listing} key={listing.id} />
          ))}
          {showSentinel && <div ref={sentineRef} />}
          {isFetchingNextPage && <ListingLoader />}
        </div>
        {!isLoading && !isFetchingNextPage && !hasNextPage && (
          <div className="uk-animation-slide-top">
            <h4 className="uk-text-center">Fine risultati</h4>
          </div>
        )}
      </div>
      {(isLoading || isFetchingNextPage) && <ListingLoader />}
    </div>
  );
}
